import React from 'react';
export function Footer() {
  return <footer className="w-full bg-navy-deep px-5 py-14 text-center text-blue-100/80 sm:px-6" data-id="element-97" data-mp="32wmp7tw7bauh">
      <div className="mx-auto max-w-3xl" data-id="element-98" data-mp="3ggu1cr6lbz9g">
        <p className="font-display text-xl font-extrabold text-gold-soft" data-id="element-99" data-mp="32o4ao9g4a660">LIBROFY.STORE™</p>
        <p className="mx-auto mt-4 max-w-xl text-[15px]" data-id="element-100" data-mp="36pfutzg81z6t">
          El sistema N°1 de automatización profesional para agentes de seguros independientes de
          Argentina.
        </p>
        <p className="mx-auto mt-3 max-w-xl text-[15px] text-blue-100/70" data-id="element-101" data-mp="3ud7hnwze1umc">
          Porque vender seguros no debería costarte todos los domingos de tu vida.
        </p>

        <div className="mt-6 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-sm" data-id="element-102" data-mp="3ldu34pweqfur">
          <span data-id="element-103" data-mp="3qbvnrf9hen8c">📧 hola@librofy.store</span>
          <span data-id="element-104" data-mp="29zglw3w5synp">📲 @librofy.store</span>
          <span data-id="element-105" data-mp="29ydvry6nv08u">🌐 www.librofy.store</span>
        </div>

        <p className="mx-auto mt-8 max-w-lg border-t border-white/10 pt-8 text-[15px] italic text-blue-100/70" data-id="element-106" data-mp="2ey0907mhoghn">
          “El próximo domingo a las 11 de la noche puede ser diferente.” — Librofy.store
        </p>

        <p className="mt-6 text-xs text-blue-200/50" data-id="element-107" data-mp="3gaz1n2bhmjjk">
          © Librofy™ 2024 — Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}